export default {
  "pages.layouts.userLayout.title": "轻量仓库管理",
  "pages.login.pageTitle": "登录 / 注册",
  "pages.login.success": "登录成功",
  "pages.login.failure": "登录失败，请重试",
  "pages.login.email.placeholder": "邮箱",
  "pages.login.email.required": "请输入邮箱",
  "pages.login.email.invalid": "请输入有效的邮箱地址",
  "pages.login.brandPitch": "为个人和小团队打造的轻量出入库 · 库存 · 盘点工具",
  "pages.login.heroTitle": "用 AI 转动库存。\n思考、决策。",
  "pages.login.heroSubtitle":
    "在 LINE 上发送「苹果 入库 20 个」即可。AI 告诉你补货时机，月底自动生成经营报表。",
  "pages.login.slogan.1": "用 AI 转动库存。",
  "pages.login.slogan.2": "说一句话，记录就留下。",
  "pages.login.slogan.3": "断货之前，AI 提醒你。",
  "pages.login.slogan.4": "月报也能自动生成。",
  "pages.login.line": "使用 LINE 继续",
  "pages.login.google": "使用 Google 继续",
  "pages.login.or": "或",
  "pages.login.socialComingSoon": "{provider} 登录即将开放",
  "pages.login.privacy":
    "继续即表示同意我们的<terms>服务条款</terms>与<privacy>隐私政策</privacy>。",
  "pages.login.openMailbox.gmail": "打开 Gmail ↗",
  "pages.login.openMailbox.yahooJp": "打开 Yahoo!邮箱 ↗",
  "pages.login.openMailbox.yahoo": "打开 Yahoo Mail ↗",
  "pages.login.openMailbox.icloud": "打开 iCloud 邮箱 ↗",
  "pages.login.openMailbox.outlook": "打开 Outlook ↗",
  "pages.login.code.send": "用邮箱继续",
  "pages.login.code.placeholder": "6 位验证码",
  "pages.login.code.required": "请输入验证码",
  "pages.login.code.invalid": "请输入 6 位数字",
  "pages.login.code.sent": "验证码已发送",
  "pages.login.code.sentTo": "请输入发送到以下邮箱的验证码：{email}",
  "pages.login.code.sendFailed": "验证码发送失败",
  "pages.login.code.resendIn": "{seconds} 秒后可重新发送",
  "pages.login.code.resend": "重新发送验证码",
  "pages.login.continue": "继续",
  "pages.login.changeEmail": "← 修改邮箱",
  "pages.login.method.email": "邮箱",
  "pages.login.method.password": "账号・密码",
  "pages.login.username.placeholder": "用户名或邮箱",
  "pages.login.username.required": "请输入用户名或邮箱",
  "pages.login.password.placeholder": "密码",
  "pages.login.password.required": "请输入密码",
  "pages.login.password.submit": "登录",
  "pages.404.subTitle": "抱歉，您访问的页面不存在",
  "pages.404.buttonText": "返回首页",
  "pages.502.title": "无法连接到服务器",
  "pages.502.subTitle": "服务器暂时没有响应，请稍后重试。",
  "pages.502.buttonText": "重新加载",
  "pages.oauth.title": "登录处理中",
  "pages.oauth.processing": "登录处理中…",
  "pages.oauth.success": "登录成功",
  "pages.oauth.fetchUserFailed": "获取用户信息失败",
  "pages.oauth.backToLogin": "返回登录",
  "pages.oauth.error.stateMismatch": "认证信息无效，请重试。",
  "pages.oauth.error.googleFailed": "Google 认证失败，请重试。",
  "pages.oauth.error.disabled": "账号已被禁用。",
  "pages.oauth.error.closing": "该账号正在注销流程中，恢复请联系支持。",
  "pages.oauth.error.generic": "登录失败，请稍后重试。",

  // 通用
  "common.action": "操作",
  "common.edit": "编辑",
  "common.delete": "删除",
  "common.cancel": "取消",
  "common.confirm": "确认",
  "common.save": "保存",
  "common.retry": "重试",
  "common.created": "创建成功",
  "common.updated": "更新成功",
  "common.deleted": "删除成功",
  "common.createdAt": "创建时间",
  "common.reset": "重置",
  "common.export": "导出",
  "common.exporting": "正在导出...",
  "common.export.success": "导出成功",
  "common.export.noData": "没有可导出的数据",
  "common.import": "批量导入",
  "common.upload": "单击上传",

  // 产品
  "product.title": "产品管理",
  "product.name": "产品名称",
  "product.name.placeholder": "请输入产品名称",
  "product.name.required": "产品名称为必填项",
  "product.sku": "SKU",
  "product.sku.placeholder": "请输入 SKU 编码（选填）",
  "product.tags": "标签",
  "product.tags.placeholder": "输入后按回车添加标签",
  "product.threshold": "低库存阈值",
  "product.threshold.placeholder": "请输入低库存阈值",
  "product.threshold.invalid": "请输入有效的阈值",
  "product.threshold.tooltip":
    "若产品包含规格，此值不参与状态判定，仅作为新增规格时的默认阈值；规格的状态以各自阈值为准。",
  "product.threshold.parentDefault": "默认 {value}",
  "product.status": "状态",
  "product.status.active": "正常",
  "product.status.archived": "已归档",
  "product.create": "新建产品",
  "product.create.manual": "手动录入",
  "product.edit": "编辑产品",
  "product.archive": "归档",
  "product.unarchive": "恢复",
  "product.archived": "已归档",
  "product.unarchived": "已恢复",
  "product.delete.confirm": "确定删除该产品吗？",
  "product.imageUrl": "产品图片",
  "product.specSize": "规格尺寸",
  "product.specSize.placeholder": "例如: 58*36*16",
  "product.remark": "备注",
  "product.remark.placeholder": "请输入备注（选填）",
  "product.contact": "往来单位",
  "product.contact.placeholder": "请选择往来单位（选填）",
  "product.unit": "单位",
  "product.barcode": "条码",
  "product.unitPrice": "单价",
  "product.unitPrice.placeholder": "请输入单价（选填）",
  "product.detail": "产品详情",
  "product.specDetail": "规格详情",
  "product.notFound": "产品不存在",
  "product.recentTransactions": "最近出入库记录",
  "product.batchThreshold": "批量设置阈值",
  "product.batchThreshold.desc": "将为选中的 {count} 个产品设置低库存阈值：",
  "product.image.hint": "最多上传 3 张",
  "product.spec": "规格",
  "product.spec.add": "添加规格",
  "product.spec.name": "规格名称",
  "product.spec.list": "规格列表",
  "product.spec.images": "规格图片",
  "product.parentProduct": "所属产品",
  "product.hasSpecs": "含规格",
  "product.noSpecs": "暂无规格",
  "product.specCount": "个规格",
  "product.specsColumn": "包含规格",
  "product.spec.select": "请选择规格",
  "product.delete.hasChildren": "该产品包含规格，请先删除所有规格",

  // 库存
  "stock.title": "库存查看",
  "stock.quantity": "库存数量",
  "stock.status": "库存状态",
  "stock.status.normal": "正常",
  "stock.status.low": "低库存",
  "stock.status.out": "缺货",
  "stock.updatedAt": "最后更新",
  "stock.history.view": "变更历史",
  "stock.history.title": "库存变更历史",
  "stock.history.type": "类型",
  "stock.history.quantity": "数量",
  "stock.history.type.inventoryCheck": "盘点调整",
  "stock.history.type.manual": "手动调整",
  "stock.history.total": "共 {total} 条记录",
  "stock.count": "盘点",
  "stock.count.start": "开始盘点",
  "stock.count.started": "盘点已开始",
  "stock.count.banner": "盘点中 · {date} · 已盘 {count} 件 · 差异 {variance} 项",
  "stock.count.status": "盘点状态",
  "stock.count.uncounted": "未盘",
  "stock.count.counted": "实盘 {qty}",
  "stock.count.title": "盘点录入",
  "stock.count.saved": "已保存",
  "stock.count.noNext": "没有更多未盘商品了",
  "stock.count.noSpecs": "该商品暂无规格，无法盘点",
  "stock.count.loadFailed": "盘点数据加载失败",
  "stock.count.loadFailed.desc":
    "当前盘点状态可能不准确，为避免覆盖已录入的实盘数，盘点功能已暂时停用。请点击重试。",

  // 交易记录（出入库）
  "transaction.title": "出入库",
  "transaction.operation": "出入库操作",
  "transaction.tab.register": "入出库登记",
  "transaction.tab.history": "入出库历史",
  "transaction.batch.title": "入出库登记",
  "transaction.batch.items": "产品明细",
  "transaction.batch.addProduct": "添加产品",
  "transaction.batch.empty": "请至少添加一个产品并填写数量",
  "transaction.batch.empty.hint": "尚未添加产品，点击「添加产品」开始",
  "transaction.batch.duplicate": "该产品/规格已在明细中",
  "transaction.batch.itemCount": "品目数",
  "transaction.batch.totalQty": "数量合计",
  "transaction.contact.placeholder": "请选择往来单位（可选）",
  "transaction.history.bySlip": "按伝票",
  "transaction.history.byDetail": "按明细",
  "transaction.slip.void.confirm": "确认整笔作废该伝票（含全部明细）？",
  "transaction.productInfo": "产品信息",
  "transaction.type": "出入库类型",
  "transaction.type.in": "入库",
  "transaction.type.out": "出库",
  "transaction.quantity": "数量",
  "transaction.quantity.required": "请输入数量",
  "transaction.contact": "往来单位",
  "transaction.remark": "备注",
  "transaction.remark.placeholder": "请输入（选填）",
  "transaction.status": "状态",
  "transaction.normal": "正常",
  "transaction.voided": "已作废",
  "transaction.void": "作废",
  "transaction.void.confirm":
    "确定作废该交易记录吗？作废后将生成反向记录恢复库存。",
  "transaction.void.success": "已作废",
  "transaction.in": "入库",
  "transaction.out": "出库",
  "transaction.in.submit": "确认入库",
  "transaction.out.submit": "确认出库",
  "transaction.in.success": "入库成功",
  "transaction.out.success": "出库成功",
  "transaction.product.required": "请选择产品",
  "transaction.specList": "规格列表",
  "transaction.specName": "规格名称",
  "transaction.productSpecName": "产品名称 / 规格名称",
  "transaction.specTag": "规格",
  "transaction.specInfo": "规格信息",
  "transaction.currentStock": "当前库存",
  "transaction.transactionQty": "出入库数量",
  "transaction.referenceNo": "出入库单号",
  "transaction.referenceNo.placeholder": "请输入",
  "transaction.transactionDate": "出入库日期",
  "transaction.remainingStock": "剩余库存",
  "transaction.unitPrice": "单价",
  "transaction.operator": "操作人",
  "transaction.history": "出入库记录",
  "transaction.selectProduct": "选择产品",
  "transaction.select": "选择",
  "transaction.addProduct": "新增产品",
  "transaction.searchProduct": "产品名称",
  "transaction.submit": "提交",
  "transaction.clearCancel": "清空/取消",
  "transaction.selectProductHint": "请先选择一个产品",
  "transaction.notSet": "未设置",
  "transaction.search.productName": "产品名称",
  "transaction.search.dateRange": "操作时间",
  "transaction.search.stockRange": "库存",
  "transaction.search.min": "库存最小值",
  "transaction.search.max": "库存最大值",

  // Dashboard
  "dashboard.title": "工作台",
  "dashboard.totalProducts": "产品总数",
  "dashboard.totalStock": "库存总量",
  "dashboard.todayIn": "今日入库",
  "dashboard.todayOut": "今日出库",
  "dashboard.lowStockAlert": "低库存预警",
  "dashboard.recentTransactions": "最近记录",
  "dashboard.unit": "种",
  "dashboard.items": "件",
  "dashboard.vsYesterday": "较昨日",
  "dashboard.lowStockCount": "低库存产品",
  "dashboard.outOfStockCount": "缺货产品",
  "dashboard.txTrend": "出入库趋势",
  "dashboard.stockDistribution": "库存状态分布",
  "dashboard.topProducts": "产品出入库排行",
  "dashboard.7days": "近7天",
  "dashboard.14days": "近14天",
  "dashboard.30days": "近30天",
  "dashboard.viewAll": "查看全部",
  "dashboard.noLowStock": "暂无低库存产品",
  "dashboard.outOfStockAlert": "需要处理",
  "dashboard.noOutOfStock": "无缺货产品",
  "dashboard.subtitle": "一目了然查看库存状况与待办",
  "dashboard.kpi.title": "库存概况",
  "dashboard.kpi.products": "商品数",
  "dashboard.kpi.outOfStock": "缺货",
  "dashboard.kpi.lowStock": "低库存",
  "dashboard.kpi.monthOutbound": "本月出库件数",
  "dashboard.actions.title": "需要处理",
  "dashboard.actions.count": "{count} 件",
  "dashboard.actions.viewAll": "查看全部",
  "dashboard.actions.empty": "暂无需要处理的项目",
  "dashboard.actions.tag.check": "盘点",
  "dashboard.actions.checkOverdue.empty": "尚无盘点记录",
  "dashboard.actions.checkOverdue.days": "{days} 天未盘点",
  "dashboard.actions.tag.out": "缺货",
  "dashboard.actions.tag.low": "少",
  "dashboard.actions.detail.remaining": "余 {qty}",
  "dashboard.actions.detail.remainingThreshold": "余 {qty} / 阈值 {threshold}",
  "dashboard.ai.bind.title": "关联 LINE 接收 AI 建议",
  "dashboard.ai.bind.desc": "在 LINE 输入「苹果 入库 20个」即可。AI 每天早上自动推送补充建议。",
  "dashboard.ai.bind.cta": "立即关联",
  "dashboard.ai.recommend.title": "今日 AI 推荐",
  "dashboard.ai.recommend.count": "{count} 条",
  "dashboard.ai.recommend.viewAll": "查看全部",
  "dashboard.ai.urgency.high": "紧急",
  "dashboard.ai.urgency.medium": "注意",
  "dashboard.ai.urgency.low": "预防",
  "dashboard.ai.product.unknown": "（未指定商品）",
  "dashboard.ai.recommend.qtyHint": "件推荐 / 库存 {stock}",

  // 联系人
  "contact.title": "往来单位",
  "contact.name": "名称",
  "contact.name.required": "请输入联系人名称",
  "contact.type": "类型",
  "contact.type.placeholder": "输入后按回车添加类型标签",
  "contact.type.tooltip": "自由录入，例如：供应商、客户、物流公司等，用于对往来单位分类。",
  "contact.remark": "备注",
  "contact.create": "新建联系人",
  "contact.edit": "编辑联系人",
  "contact.delete.confirm": "确定删除该联系人吗？",


  // 盘点
  "inventoryCheck.title": "盘点管理",
  "inventoryCheck.date": "盘点日期",
  "inventoryCheck.status": "状态",
  "inventoryCheck.status.open": "进行中",
  "inventoryCheck.status.completed": "已完成",
  "inventoryCheck.status.voided": "已撤销",
  "inventoryCheck.completedAt": "完成时间",
  "inventoryCheck.view": "查看",
  "inventoryCheck.detail": "盘点详情",
  "inventoryCheck.items": "盘点项",
  "inventoryCheck.bookQty": "账面数量",
  "inventoryCheck.actualQty": "实际数量",
  "inventoryCheck.difference": "差异",
  "inventoryCheck.complete": "确认盘点",
  "inventoryCheck.complete.confirm": "确认完成盘点？完成后将生成库存调整记录。",
  "inventoryCheck.complete.noItems": "请先在库存页盘点商品",
  "inventoryCheck.completed": "盘点已完成",
  "inventoryCheck.void": "撤销",
  "inventoryCheck.void.confirm": "确定撤销该盘点吗？",
  "inventoryCheck.voided": "盘点已撤销",
  "inventoryCheck.notFound": "盘点单不存在",
  "inventoryCheck.inputActualQty": "输入实际数量",
  "inventoryCheck.actualQty.empty": "未填",
  "inventoryCheck.actualQty.required": "请输入实盘数，不能为空",
  "inventoryCheck.continueActive": "继续进行中的盘点",
  "inventoryCheck.active.viewSheet": "查看盘点单",
  "inventoryCheck.active.completeNow": "完成盘点",
  "inventoryCheck.matchBook": "与账面一致",
  "inventoryCheck.saveAndNext": "保存并盘下一个",
  "inventoryCheck.removeItem": "撤销本项",
  "inventoryCheck.removed": "已撤销该商品的盘点",
  "inventoryCheck.progress": "已盘商品",
  "inventoryCheck.varianceCount": "差异项数",
  "inventoryCheck.varianceTotal": "差异合计",
  "inventoryCheck.variance.match": "一致",
  "inventoryCheck.drift.title": "部分商品的账面数已变化",
  "inventoryCheck.drift.desc":
    "以下商品在盘点期间发生过出入库，库存已按盘点差异调整，请确认：",
  "inventoryCheck.currentQty": "当前库存",
  "inventoryCheck.item.search": "搜索商品 / SKU",
  "inventoryCheck.items.loadFailed": "盘点项加载失败",
  "inventoryCheck.items.loadFailed.desc":
    "当前列表可能不完整。为避免误撤销一张有数据的盘点单，撤销操作已暂时停用，请重试。",
  "inventoryCheck.item.delete": "删除",
  "inventoryCheck.item.deleted": "已删除盘点项",
  "inventoryCheck.item.delete.confirm": "确定删除该盘点项吗？",
  "inventoryCheck.goStockCount": "去库存页盘点",
  "inventoryCheck.export": "导出",
  "inventoryCheck.export.filename": "盘点表",
  "inventoryCheck.export.failed": "导出失败，请稍后重试",
  "inventoryCheck.itemCount": "已盘件数",
  "inventoryCheck.list.hint": "盘点从库存页发起，这里是历史台账",
  "inventoryCheck.complete.result": "盘点已完成，共调整 {count} 个商品",

  // 设置
  "settings.tab.account": "账户设置",
  "settings.tab.security": "安全设置",
  "settings.tab.business": "业务设置",
  "settings.tab.subscription": "订阅信息",
  "settings.account.info": "账户信息",
  "settings.account.username": "用户名",
  "settings.account.tenant": "租户 ID",
  "settings.account.userCode": "用户编号",
  "settings.account.createdAt": "注册时间",
  "lang.ja-JP": "日语",
  "lang.en-US": "英语",
  "lang.zh-CN": "简体中文",
  "lang.zh-TW": "繁体中文",
  "settings.account.displayName": "显示名称",
  "settings.account.displayNamePlaceholder": "请输入显示名称",
  "settings.account.displayNameHint": "设置后，将代替账号显示",
  "settings.account.displayNameEdit": "更改",
  "settings.account.displayNameSuccess": "显示名称已更新",
  "settings.password.title": "修改密码",
  "settings.password.changeDesc": "使用邮箱验证码即可修改为新密码，无需填写当前密码。",
  "settings.password.old": "当前密码",
  "settings.password.new": "新密码",
  "settings.password.confirm": "确认新密码",
  "settings.password.minLength": "密码长度不能少于 6 位",
  "settings.password.mismatch": "两次输入的密码不一致",
  "settings.password.submit": "修改密码",
  "settings.password.success": "密码修改成功",
  "settings.password.code": "验证码",
  "settings.password.codePlaceholder": "6 位验证码",
  "settings.password.sendCode": "发送验证码",
  "settings.password.codeResendIn": "{seconds} 秒后重新发送",
  "settings.password.codeSent": "验证码已发送",
  "settings.password.codeSentTo": "验证码将发送至 {email}",
  "settings.password.codeInvalid": "请输入 6 位数字",
  "settings.business.title": "业务配置",
  "settings.business.defaultThreshold": "默认低库存阈值",
  "settings.business.defaultThreshold.tip": "新建产品时的默认低库存阈值",
  "settings.business.save": "保存设置",
  "settings.fieldVisibility.title": "字段显示",
  "settings.fieldVisibility.desc":
    "按需开启或关闭字段，列表与表单将自动应用。关闭的字段在录入时不会出现，已有数据保留不受影响。",
  "settings.fieldVisibility.updated": "已更新",
  "settings.fieldVisibility.entity.product": "产品",
  "settings.fieldVisibility.field.product.sku": "SKU",
  "settings.fieldVisibility.field.product.specSize": "规格尺寸",
  "settings.fieldVisibility.field.product.contact": "往来单位",
  "settings.fieldVisibility.field.product.unit": "单位",
  "settings.fieldVisibility.field.product.barcode": "条码",
  "settings.fieldVisibility.field.product.unitPrice": "单价",
  "settings.fieldVisibility.entity.transaction": "出入库记录",
  "settings.fieldVisibility.field.transaction.unitPrice": "出入库单价",
  "settings.tab.app": "App设置",
  "settings.app.title": "App定制",
  "settings.app.icon": "App图标",
  "settings.app.icon.desc":
    "上传自定义图标，用于移动应用展示。推荐使用 1024×1024 像素的 PNG 图片。",
  "settings.app.icon.upload": "上传图标",
  "settings.app.icon.change": "更换图标",
  "settings.app.icon.delete": "删除图标",
  "settings.app.icon.deleteConfirm": "确定删除当前图标吗？",
  "settings.app.icon.requirement": "PNG 格式，正方形，建议 1024×1024 px",
  "settings.app.icon.success": "图标更新成功",
  "settings.app.icon.deleteSuccess": "图标已删除",
  "settings.app.icon.sizeError": "图片尺寸需为正方形且不小于 512×512 像素",
  "settings.subscription.title": "当前订阅",
  "settings.subscription.plan": "套餐",
  "settings.subscription.maxProducts": "产品上限",
  "settings.subscription.maxTransactions": "月交易上限",
  "settings.subscription.perMonth": " 笔/月",

  // 反馈
  "feedback.title": "意见反馈",
  "feedback.submit": "提交反馈",
  "feedback.submit.success": "感谢您的反馈，我们会尽快处理",
  "feedback.category": "类别",
  "feedback.category.bug": "Bug",
  "feedback.category.suggestion": "建议",
  "feedback.category.feature": "功能请求",
  "feedback.category.dissatisfied": "不满意",
  "feedback.content": "反馈内容",
  "feedback.content.placeholder": "请描述您遇到的问题或建议...",
  "feedback.content.required": "请输入反馈内容",
  "feedback.screenshot": "截图（选填）",
  "feedback.screenshot.add": "截图",
  "feedback.screenshot.typeError": "只能上传图片文件",
  "feedback.screenshot.sizeError": "图片大小不能超过 2MB",
  "feedback.contactEmail": "联系邮箱（选填）",
  "feedback.contactEmail.placeholder": "方便我们回复您",
  "feedback.contactEmail.invalid": "请输入有效的邮箱地址",

  // NPS 调查
  "nps.title": "您愿意把这个产品推荐给朋友吗？",
  "nps.subtitle": "0 = 完全不愿意，10 = 非常愿意",
  "nps.unlikely": "不太可能",
  "nps.likely": "非常可能",
  "nps.comment.placeholder": "有什么想告诉我们的？（选填）",
  "nps.thanks": "感谢您的评价！",

  // 订阅 & 升级
  "subscription.unlimited": "无限制",
  "subscription.upgrade.title": "升级到 Pro",
  "subscription.upgrade.desc": "解锁全部功能，提升工作效率",
  "subscription.upgrade.button": "立即升级",
  "subscription.upgrade.success": "升级成功",
  "subscription.upgrade.feature.export": "支持导出 Excel / CSV",
  "subscription.upgrade.feature.unlimited": "无限产品和交易记录",
  "subscription.upgrade.feature.stats": "基础统计与数据分析",

  // 定价页
  "pricing.title": "选择适合您的方案",
  "pricing.subtitle": "从免费方案开始，随时升级解锁更多功能",
  "pricing.monthly": "月付",
  "pricing.annual": "年付",
  "pricing.save": "省 {percent}%",
  "pricing.free": "免费",
  "pricing.freeDesc": "适合入门体验基础仓库管理",
  "pricing.proDesc": "解锁全部功能，无限制使用",
  "pricing.upgradeNow": "立即升级",
  "pricing.currentPlan": "当前方案",
  "pricing.currentPlanBtn": "当前方案",
  "pricing.downgrade": "降级",
  "pricing.recommended": "推荐",
  "pricing.perMonth": "月",
  "pricing.billedAnnually": "按年付费共 {amount}",
  "pricing.note": "所有方案均支持 14 天免费试用，无需绑定银行卡",
  "pricing.noPriceConfig": "暂无可用价格配置，请稍后再试",
  "pricing.checkoutFailed": "无法跳转到支付页面，请稍后再试",
  "pricing.unlimited": "无限制",
  "pricing.feature.products": "产品管理",
  "pricing.feature.transactions": "交易记录",
  "pricing.feature.stockManagement": "库存管理",
  "pricing.feature.inventoryCheck": "盘点功能",
  "pricing.feature.export": "导出 Excel / CSV",
  "pricing.feature.statistics": "数据统计与分析",
  "pricing.feature.scan": "扫码入库",

  // 设置 - 订阅管理
  "settings.subscription.status": "状态",
  "settings.subscription.nextBilling": "下次扣款日",
  "settings.subscription.viewPlans": "查看方案",
  "settings.subscription.changePlan": "更改套餐",
  "settings.subscription.manageBilling": "管理账单",
  "settings.subscription.cancel": "取消订阅",
  "settings.subscription.cancelConfirmTitle": "确认取消订阅？",
  "settings.subscription.cancelConfirmDesc":
    "取消后当前账期结束前仍可使用 Pro 功能，之后将降级为免费方案。",
  "settings.subscription.confirmCancel": "确认取消",
  "settings.subscription.cancelSuccess":
    "已取消订阅，当前账期结束后将降级为免费方案",
  "settings.subscription.portalFailed": "无法打开账单管理页面，请稍后再试",
  "settings.subscription.gracePeriodWarning": "付款失败",
  "settings.subscription.gracePeriodDesc":
    "您的订阅付款未成功，请在 {date} 前更新支付方式，否则将自动降级为免费方案。",
  "settings.subscription.trialRemaining": "试用期剩余 {days} 天",

  // ─── 智能分析 ──────────────────────────────────────────────────
  "analytics.title": "智能分析",
  "analytics.shipmentTrend": "出货趋势",
  "analytics.replenishment": "补货建议",
  "analytics.productAnalysis": "产品分析",
  "analytics.movingAverage": "移动平均",
  "analytics.periodicity": "周期性检测",
  "analytics.granularity.day": "按天",
  "analytics.granularity.week": "按周",
  "analytics.granularity.month": "按月",
  "analytics.timeRange": "时间范围",
  "analytics.tags": "标签筛选",
  "analytics.includeInbound": "显示入库",
  "analytics.outbound": "出库",
  "analytics.inbound": "入库",
  "analytics.last30days": "近30天",
  "analytics.last90days": "近90天",
  "analytics.custom": "自定义",
  "analytics.items": "件",
  "analytics.days": "天",
  "analytics.dailyOut": "日出库量",
  "analytics.ma7": "7日均线",
  "analytics.ma14": "14日均线",
  "analytics.dow.1": "周一",
  "analytics.dow.2": "周二",
  "analytics.dow.3": "周三",
  "analytics.dow.4": "周四",
  "analytics.dow.5": "周五",
  "analytics.dow.6": "周六",
  "analytics.dow.7": "周日",
  "analytics.peakDay": "峰值日",
  "analytics.avgOut": "平均出库量",
  "analytics.urgency": "紧急程度",
  "analytics.urgency.all": "全部",
  "analytics.urgency.immediate": "立即补货",
  "analytics.urgency.today": "今天",
  "analytics.urgency.thisWeek": "本周内",
  "analytics.urgency.twoWeeks": "两周内",
  "analytics.urgency.noAction": "无需补货",
  "analytics.currentStock": "当前库存",
  "analytics.dailyAvgOut": "日均出货",
  "analytics.estimatedDaysLeft": "预计耗尽",
  "analytics.suggestedQuantity": "建议补货量",
  "analytics.insufficientData": "数据积累中",
  "analytics.insufficientDataDesc":
    "需要更多出货记录才能生成分析，请继续使用系统。",
  "analytics.insufficientDataCount": "{count} 个产品数据不足",
  "analytics.selectProduct": "选择产品查看详细分析",
  "analytics.viewAnalysis": "查看分析",
  "analytics.formulaNote": "计算说明",
  "analytics.perDay": "件/天",
  "analytics.aboutDays": "约 {days} 天",

  // --- 退出登录 ---
  "settings.account.logout": "退出登录",
  "settings.account.logoutDesc": "退出当前账户，下次需重新登录。",
  "settings.account.logoutConfirmTitle": "确认退出登录？",

  // --- 注销账户 ---
  "settings.account.dangerZone": "危险操作",
  "settings.account.deleteAccount": "注销账户",
  "settings.account.deleteAccountDesc":
    "注销后，账户将在30天后被永久删除。在此期间，您可以随时通过登录恢复账户。",
  "settings.account.deleteConfirmTitle": "确认注销账户？",
  "settings.account.deleteConfirmDesc":
    "请输入密码以确认注销。注销后您将被登出，30天内可通过登录恢复账户。",
  "settings.account.deleteConfirmPassword": "请输入密码",
  "settings.account.deleteConfirmEmailDesc":
    "请输入账户邮箱 {email} 以确认注销。注销后您将被登出，30天内可通过登录恢复账户。",
  "settings.account.deleteConfirmEmailRequired": "请输入账户邮箱",
  "settings.account.deleteConfirmEmailMismatch": "邮箱与账户不一致",
  "settings.account.deleteDataNotice": "30天后以下数据将被永久清空且无法恢复",
  "settings.account.deleteDataItem.records": "出入库记录",
  "settings.account.deleteDataItem.stock": "库存记录",
  "settings.account.deleteDataItem.products": "产品记录",
  "settings.account.deleteDataItem.user": "用户信息",
  "settings.account.deleteSuccess": "账户注销请求已提交",

  // --- 账户恢复 ---
  "accountClosing.title": "账户注销中",
  "accountClosing.desc":
    "您的账户已申请注销，还剩 {days} 天可恢复。超期后所有数据将被永久删除。",
  "accountClosing.restore": "恢复账户",
  "accountClosing.restoreConfirmTitle": "确认恢复账户？",
  "accountClosing.restoreConfirmPassword": "请输入密码确认恢复",
  "accountClosing.restoreConfirmEmail": "请输入账户邮箱 {email} 确认恢复",
  "accountClosing.restoreSuccess": "账户已恢复，欢迎回来",
  "accountClosing.logout": "退出登录",

  // 通知
  "notice.tab.system": "系统通知",
  "notice.tab.todo": "待办提醒",
  "notice.empty": "暂无通知",
  "notice.todo.empty": "暂无待办",
  "notice.readAll": "全部标为已读",
  "notice.markSelectedRead": "标记已读",
  "notice.selected": "已选 {count} 条",
  "notice.viewAll": "查看全部",

  "notice.col.content": "消息内容",
  "notice.col.time": "接收时间",
  "notice.col.type": "消息类型",
  "notice.type.notice": "通知",
  "notice.type.announcement": "公告",
  "notice.detail.title": "消息详情",
  "notice.pagination.total": "共 {total} 条",

  // 团队邀请
  "invitation.inbox.title": "待处理邀请",
  "invitation.inbox.line": "{inviter} 邀请你加入「{team}」团队",
  "invitation.inbox.expiresAt": "有效期至 {date}",
  "invitation.accept": "接受",
  "invitation.decline": "拒绝",
  "invitation.declineConfirm": "确定要拒绝此邀请吗？",
  "invitation.acceptSuccess": "已加入「{team}」，可在右上角切换团队",

  // 设置 - 通知消息
  "settings.tab.notices": "通知消息",
  "settings.notices.title": "通知消息",

  // 设置 - 团队管理
  "settings.tab.team": "团队管理",
  "team.title": "团队成员",
  "team.invite": "邀请成员",
  "team.invite.title": "邀请新成员",
  "team.invite.email": "邮箱",
  "team.invite.emailInvalid": "请输入正确的邮箱",
  "team.invite.displayName": "显示名（可选）",
  "team.invite.displayName.tip": "对方接受邀请后默认使用此名称",
  "team.invite.message": "留言（可选）",
  "team.invite.checking": "正在检查邮箱…",
  "team.invite.alreadyMember": "该邮箱已经是本团队成员",
  "team.invite.alreadyPending": "该邮箱已有未处理的邀请，可点击「重发」重新发送邮件",
  "team.invite.accountExists": "该邮箱已注册 stockware，对方接受后将作为成员加入",
  "team.invite.accountNew": "对方将通过该邮箱注册并加入团队",
  "team.invite.success": "邀请已发送",
  "team.invite.resend": "重发",
  "team.invite.resendSuccess": "邀请已重发",
  "team.invite.revoke": "撤销",
  "team.invite.revokeConfirm": "确定撤销此邀请吗？",
  "team.invite.col.email": "邮箱",
  "team.invite.col.expiresAt": "过期时间",
  "team.invite.col.createdAt": "邀请时间",
  "team.invitations.title": "待处理邀请",
  "teamSwitcher.title": "切换团队",
  "teamSwitcher.switched": "已切换到「{team}」",
  "team.col.displayName": "昵称",
  "team.col.username": "用户名",
  "team.col.role": "角色",
  "team.col.status": "状态",
  "team.role.owner": "主账号",
  "team.role.member": "成员",
  "team.status.active": "正常",
  "team.status.disabled": "已禁用",
  "team.status.invited": "待邀请",
  "team.edit": "编辑",
  "team.edit.success": "成员信息已更新",
  "team.remove": "移除",
  "team.remove.confirm": "确定移除该成员吗？移除后该账号将无法登录。",
  "team.disable": "禁用",
  "team.enable": "启用",
  "team.permissions": "权限配置",
  "team.permissions.title": "编辑权限 - {name}",
  "team.permissions.selectAll": "全选",
  "team.permissions.resetDefaults": "恢复默认",
  "team.permissions.resetDefaults.confirm": "确定恢复为默认权限吗？",
  "team.permissions.save.success": "权限配置已保存",
  "team.permissions.reset.success": "已恢复默认权限",
  "team.permissions.custom": "自定义",
  "team.permissions.default": "默认",
  "team.permissions.col.category": "分类",
  "team.permissions.col.target": "操作对象",
  "team.permissions.col.permissions": "功能权限",
  "team.permissions.module.warehouse": "仓储管理",
  "team.permissions.module.smart_analytics": "智能分析",
  "team.permissions.group.product": "产品管理",
  "team.permissions.group.stock": "库存",
  "team.permissions.group.transaction": "出入库",
  "team.permissions.group.inventory-check": "盘点",
  "team.permissions.group.contact": "往来单位",
  "team.permissions.group.expense": "支出",
  "team.permissions.group.income": "收入",
  "team.permissions.group.analytics": "数据分析",
  "team.permissions.action.list": "查看",
  "team.permissions.action.add": "新增",
  "team.permissions.action.edit": "编辑",
  "team.permissions.action.delete": "删除",
  "team.permissions.action.void": "作废",
  "team.permissions.action.export": "导出",
  "team.permissions.action.view": "查看",
  "team.permissions.action.category": "分类管理",

  // 首次登录修改密码
  "changeInitialPassword.title": "修改初始密码",
  "changeInitialPassword.hint": "为了账号安全，建议修改初始密码",
  "changeInitialPassword.new": "新密码",
  "changeInitialPassword.confirm": "确认新密码",
  "changeInitialPassword.submit": "确认修改",
  "changeInitialPassword.skip": "跳过，稍后修改",
  "changeInitialPassword.success": "密码修改成功",

  // 14 天试用邀请弹窗
  "trialOffer.title": "免费试用 Pro 14 天",
  "trialOffer.subtitle": "无需绑卡，体验全部 Pro 功能",
  "trialOffer.body": "您当前是免费版用户，试用期间可解锁全部功能，14 天后自动恢复为免费版。仅限一次。",
  "trialOffer.accept": "立即开启试用",
  "trialOffer.decline": "暂不试用",
  "trialOffer.successMessage": "试用已开启，祝您使用愉快",
  "trialOffer.failedMessage": "开启试用失败，请稍后重试",

  // 公开支持页（/support），作为 App Store「支持网址」提交
  "pages.support.pageTitle": "支持中心",
  "pages.support.lead":
    "这里是库存管理应用 Stockware 的用户支持页。请先查看下方常见问题；如果仍未解决，欢迎随时联系我们。",
  "pages.support.contact.heading": "联系我们",
  "pages.support.contact.intro":
    "使用过程中遇到问题，或有功能建议，请通过以下邮箱联系我们。同时告知您使用的设备（iPhone / Android / 浏览器）、应用版本以及具体情况，可以让我们更快地为您处理。",
  "pages.support.contact.operatorLabel": "运营主体",
  "pages.support.contact.emailLabel": "邮箱",
  "pages.support.contact.hoursLabel": "受理时间",
  "pages.support.contact.hoursValue": "工作日 10:00–18:00（日本时间，节假日除外）",
  "pages.support.contact.replyLabel": "回复时间",
  "pages.support.contact.replyValue": "2–3 个工作日内",
  "pages.support.faq.heading": "常见问题",
  "pages.support.faq.q1": "无法登录，收不到验证码邮件。",
  "pages.support.faq.a1":
    "Stockware 支持邮箱 6 位验证码、密码以及 Google 账号三种登录方式。如果收不到验证码，请先检查垃圾邮件文件夹，并在 60 秒后点击「重新发送验证码」。若仍未收到，请联系我们。",
  "pages.support.faq.q2": "忘记密码了。",
  "pages.support.faq.a2":
    "在登录页选择「使用邮箱验证码登录」即可免密码登录。登录后进入应用的「我的 → 设置 → 修改密码」，通过邮箱验证码设置新密码，无需输入原密码。",
  "pages.support.faq.q3": "库存数量和实际对不上。",
  "pages.support.faq.a3":
    "请使用盘点功能。在库存页发起盘点，录入实际清点的数量，系统会自动计算与账面数的差异；确认后自动生成库存调整记录。若盘点期间该商品发生了出入库，确认时会提示您。",
  "pages.support.faq.q4": "想删除误建的商品。",
  "pages.support.faq.a4":
    "可在商品列表或商品详情中「归档」，归档后不再出现在常规列表中，出入库记录仍会保留。如需彻底移除请使用「删除」。删除不可撤销，已有出入库记录的商品建议归档。",
  "pages.support.faq.q5": "可以和员工或家人一起使用吗？",
  "pages.support.faq.a5":
    "可以。在「我的 → 团队管理」中通过邮箱邀请成员，可为每位成员单独设置角色（所有者 / 成员）与权限，也可停用或移除。若同时属于多个团队，可在应用内切换。",
  "pages.support.faq.q6": "想注销账号。",
  "pages.support.faq.a6":
    "可在应用的「我的 → 设置 → 注销账号」中申请。提交后 30 天内登录即可恢复账号；超过 30 天后，出入库记录、库存记录、商品记录和用户信息将被彻底删除且无法恢复。",
  "pages.support.links.heading": "相关链接",
  "pages.support.links.site": "官方网站",
  "pages.support.links.terms": "用户协议",
  "pages.support.links.privacy": "隐私政策",
};
